import { ArrowLeft } from 'lucide-react';
import type { ReactNode } from 'react';
import { useNavigate } from 'react-router-dom';

import { cn } from '@/utils/cls';

interface PageHeaderProps {
  title: ReactNode;
  description?: ReactNode;
  /** Render a back arrow that pops the route stack */
  back?: boolean;
  /** Right-side action buttons */
  actions?: ReactNode;
  className?: string;
}

/** Used at the top of every full page so spacing/typography stay uniform. */
export function PageHeader({ title, description, back, actions, className }: PageHeaderProps) {
  const navigate = useNavigate();
  return (
    <div className={cn('flex items-start justify-between gap-4 mb-6 flex-wrap', className)}>
      <div className="flex items-start gap-3 min-w-0">
        {back && (
          <button
            type="button"
            onClick={() => navigate(-1)}
            aria-label="Back"
            className="mt-1 p-2 rounded-lg text-ink-soft hover:bg-surface-2 hover:text-ink"
          >
            <ArrowLeft className="h-5 w-5" />
          </button>
        )}
        <div className="min-w-0">
          <h1 className="text-2xl font-bold text-ink">{title}</h1>
          {description && (
            <p className="text-sm text-ink-soft mt-1">{description}</p>
          )}
        </div>
      </div>
      {actions && <div className="flex flex-wrap items-center gap-2">{actions}</div>}
    </div>
  );
}
